/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import './AppMenu.scss';
import NavigationActions from '../redux/NavigationActions';

@withRouter
@connect(({ }, { history, location }) => ({
  close: () => {
    NavigationActions.goBack(history, location.pathname);
  },
}))
export class SlidingMenuMask extends React.Component<{ close? }, {}> {
  render() {
    return (
      <div className="cmp-sliding-menu-mask" onClick={this.props.close}/>
    );
  }
}
